"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FavoriteStar = _interopRequireDefault(require("../elements/FavoriteStar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StarRating = _ref => {
  let {
    rating,
    className
  } = _ref;
  let stars = /*#__PURE__*/_react.default.createElement("span", {
    title: "0 star rating"
  });
  const starCss = `is-size-3 has-text-link ${className}`;
  switch (rating) {
    case 1:
      stars = /*#__PURE__*/_react.default.createElement("span", {
        title: `${rating} star rating`
      }, /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }));
      break;
    case 2:
      stars = /*#__PURE__*/_react.default.createElement("span", {
        title: `${rating} star rating`
      }, /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }));
      break;
    case 3:
      stars = /*#__PURE__*/_react.default.createElement("span", {
        title: `${rating} star rating`
      }, /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }));
      break;
    case 4:
      stars = /*#__PURE__*/_react.default.createElement("span", {
        title: `${rating} star rating`
      }, /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }));
      break;
    case 5:
      stars = /*#__PURE__*/_react.default.createElement("span", {
        title: `${rating} star rating`
      }, /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }), /*#__PURE__*/_react.default.createElement(_FavoriteStar.default, {
        className: starCss
      }));
      break;
    default:
      stars = /*#__PURE__*/_react.default.createElement("span", {
        title: "0 star rating"
      });
  }
  return stars;
};
StarRating.propTypes = {
  rating: _propTypes.default.number.isRequired,
  className: _propTypes.default.string
};
StarRating.defaultProps = {
  className: ''
};
var _default = exports.default = StarRating;
//# sourceMappingURL=StarRating.js.map